import { TASK_CONSTRUCTOR_PATH } from 'domain/shared/taskConstructor/constants';

export { TASK_CONSTRUCTOR_PATH };

export const TASK_CONSTRUCTOR_PAGE_SIZE = 100;

export const TASK_CONSTRUCTOR_LIST_READ = 'PEOPLE_MANAGEMENT_POSITION_SLOT_LIST_READ_LIST';
